import { VALIDATE_REQUIRED } from '@/constants';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Col, Form, Input, InputNumber, Row } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  form: any;
  isMyProfile: boolean;
};

export default function GuideAnnualWorkDay({ isMyProfile, form }: Props) {
  const { t } = useTranslation();

  return (
    <div>
      <Form.List name="annualWorkDayList">
        {(fields, { add, remove }) => (
          <div>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
              <div style={{ flex: 1 }}>過去の年間稼働日数</div>
              <Button
                type="primary"
                className="save-btn"
                onClick={() => add({ isMain: fields.length === 0 })}
                icon={<PlusOutlined />}
                style={{ marginLeft: 10 }}
              >
                {t('guideSerchadd')}
              </Button>
            </div>
            {fields.length ? (
              <Row gutter={6} className="mb-2">
                <Col md={6}>
                  <h4 className="form-label-required">稼働年</h4>
                </Col>
                <Col md={6}>
                  <h4 className="form-label-required">稼働日数</h4>
                </Col>
              </Row>
            ) : null}

            {fields.map(field => (
              <Row key={field.key} gutter={6} className="language-row">
                <Col md={6}>
                  <Form.Item name={[field.name, 'year']} rules={[{ required: true, message: VALIDATE_REQUIRED }]}>
                    <InputNumber className="w-100" min={0} precision={0} />
                  </Form.Item>
                </Col>
                <Col md={6} className="text-center">
                  <Form.Item name={[field.name, 'workingDay']} rules={[{ required: true, message: VALIDATE_REQUIRED }]}>
                    <InputNumber className="w-100" min={0} precision={0} />
                  </Form.Item>
                </Col>

                <Col md={4} className="text-center">
                  <Button
                    icon={<DeleteOutlined />}
                    className="delete-btn"
                    danger
                    onClick={() => {
                      remove(field.name);
                    }}
                    size="small"
                  >
                    削除
                  </Button>
                </Col>
              </Row>
            ))}
          </div>
        )}
      </Form.List>
    </div>
  );
}
